<template>
  <div class="Inventory">
    <keep-alive>
      <Particles v-if="slugIsIn(['10', '11', '12', '16', '20', '23'])" />
    </keep-alive>
    <Codex v-if="slugIsAfter('codec')"/>
  </div>
</template>

<script>

import Particles from '@/components/particles/Particles'
import Codex from './Codex'

export default {
  name: 'Inventory',
  components: { Particles, Codex }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Inventory
  position fixed
  pointer-events none
  width 100vw
  top 0px
  left 0px

  &__film
    position fixed
    width 410px
    height 350px
    left 50%
    top 50%
    transform translate(-50%, -50%)
    transition opacity 1s, transform 1s
    
    img
      max-height 100%
      display block
      margin 0 auto

    &-enter
    &-leave-active
      transform translate(-50%, -50%) scale(.5)
      opacity 0

</style>



// WEBPACK FOOTER //
// src/components/inventory/Inventory.vue